import React from "react";

import qs from "qs";
import { useSelector } from "react-redux";
import { Redirect, Route, RouteProps } from "react-router";
import { StringParam, useQueryParam, withDefault } from "use-query-params";

import { RootState } from "../store/root_reducer";

import { ApplicationRoute } from "./routes";

export const LoginRoute: React.FC<RouteProps> = (props) => {
  const hasToken = useSelector((state: RootState) => state.Auth.hasToken);
  const [nextUrl] = useQueryParam("next", withDefault(StringParam, ApplicationRoute.Base));

  if (!hasToken) {
    return <Route {...props} />;
  }
  return <Redirect to={nextUrl} />;
};

export const ProtectedRoute: React.FC<RouteProps> = (props) => {
  const hasToken = useSelector((state: RootState) => state.Auth.hasToken);

  if (!hasToken) {
    const next = window.location.pathname + window.location.search;
    return (
      <Route
        {...props}
        exact
        component={() => <Redirect to={{ pathname: ApplicationRoute.Login, search: qs.stringify({ next }) }} />}
      />
    );
  }

  return <Route {...props} />;
};

export interface PermissionRouteProps {
  permissions: string[];
}

export const PermissionRoute: React.FC<RouteProps & PermissionRouteProps> = (props) => {
  const userPermissions = useSelector((state: RootState) => state.User.permissions);

  const hasPermissions = props.permissions.every((permission) => userPermissions.includes(permission));

  if (!hasPermissions) {
    return <Redirect to={ApplicationRoute.Forbidden} />;
  }

  return <Route {...props} />;
};
